export const NEWS_PAGE_URLS: { [key: string]: string } = {
    'it': '/it/assistenza/news',
    'en': '/en/assistance/news'
}